import { Component, OnDestroy, OnInit } from '@angular/core';
import { IsActiveMatchOptions } from '@angular/router';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { UnitFamily } from './models/enums/unit-families';
import { IMenuItem } from './models/interfaces/IMenuItem';
import { AuthService } from './services/auth.service';
import { Utilities } from './shared/utils';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {

  langChangeSub: Subscription;

  loggedIn = false;
  loggedInSub: Subscription;

  appPages: IMenuItem[] = [];

  routerMatchOpts: IsActiveMatchOptions = {
    queryParams: 'ignored',
    matrixParams: 'ignored',
    paths: 'subset',
    fragment: 'ignored',
  };

  constructor(
    private platform: Platform,
    private authService: AuthService,
    private translationService: TranslateService) {
    this.initializeApp();
  }

  ngOnInit() {
    this.loggedInSub = this.authService.isLoggedIn.subscribe(res => {
      this.loggedIn = res;
      this.appPages = this.generatePages();
    });
  }

  ngOnDestroy() {
    this.loggedInSub?.unsubscribe();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      Utilities.storageGetItem('unitFamily').then((value) => {
        this.authService.setUnitFamily(value || UnitFamily.USCustomary);
      }).catch(() => {
        this.authService.setUnitFamily(UnitFamily.USCustomary)
      });

      this.translationService.addLangs(['en', 'es']);

      // Default Lang used as fallback when a translation is not found
      this.translationService.setDefaultLang('en');

      this.langChangeSub = this.translationService.onLangChange.subscribe(params => {
        this.translationService.getTranslation(params.lang).pipe(take(1)).subscribe(translation => {
          this.translationService.setTranslation(params.lang, translation);
        });
      });

      Utilities.storageGetItem('language').then(value => {
        // TODO see if there is a way to catch non-matching value to .json
        return this.translationService.use(value || 'en');
      }).catch(err => {
        this.translationService.use('en');
        Utilities.storageRemoveItem('language');
      });
    });
  }

  generatePages(): IMenuItem[] {
    return [
      { path: '/register', icon: 'person-add', dir: 'rs', hidden: this.loggedIn, label: 'Messages_Register', },
      { path: '/login', icon: 'log-in', dir: 'rs', hidden: this.loggedIn, label: 'Messages_Login' },
      { path: '/designs', icon: 'water', dir: 'ls', hidden: !this.loggedIn, label: 'Classes_Designs', },
      { path: '/payback', icon: 'pricetags', dir: 'ls', hidden: !this.loggedIn, label: 'Classes_Payback' },
      { path: '/customers', icon: 'people', dir: 'ls', hidden: !this.loggedIn, label: 'Classes_Customers', },
      { path: '/projects', icon: 'albums', dir: 'ls', hidden: !this.loggedIn, label: 'Classes_Projects', },
      { path: '/mainlines', icon: 'grid', dir: 'rs', hidden: !this.loggedIn, label: 'Classes_Mainlines', },
      { path: '/laterals', icon: 'folder', dir: 'rs', hidden: !this.loggedIn, label: 'Messages_CustomProducts', },
      { path: '/custom-pipe-sizes', icon: 'contrast', dir: 'rs', hidden: !this.loggedIn, label: 'Messages_CustomManifolds' },
    ];
  }
}
